import { createGlobalState, StorageSerializers, useStorage } from "@vueuse/core";
import { computed, ref } from "vue";
import { fetchResource } from "./Query/resourceQuery";

interface MercureSseTokenResponse {
  token: string
}

export const useMercureState = createGlobalState(
  () => {
    const mercureToken = useStorage<string | null>("mercure-sse-token", null, sessionStorage, {
      serializer: StorageSerializers.string,
    });
    const currentPromise = ref<Promise<MercureSseTokenResponse> | null>(null);

    async function refreshMercureToken() {
      try {
        if (!currentPromise.value) {
          currentPromise.value = fetchResource<MercureSseTokenResponse>("/api/sse/token", { gcTime: 0 });
        }
        const data = await currentPromise.value;
        mercureToken.value = data.token;
      } finally {
        currentPromise.value = null;
      }
    }

    const params = computed(() => ({
      mercureTokenGetter: () => mercureToken.value || "",
      refreshMercureToken,
    }));

    return {
      mercureToken,
      refreshMercureToken,
      params,
    };
  },
);
